import template from './teamRequestModalRemove.html';
import controller from './teamRequestModalRemove.controller';
import './teamRequestModalRemove.scss';

let teamRequestModalRemoveComponent = {
  restrict: 'E',
  bindings: {
    modalId: '@',
    request: '<',
    showSuccess: '<',
    error: '<',
    onConfirm: '&',
    onReject: '&',
    isMobileApp: '<'
  },
  template,
  controller
};

export default teamRequestModalRemoveComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalRemove/teamRequestModalRemove.component.js